import React, { Component } from 'react';
import AppLayer from './AppLayer';

class KryptonPay extends Component {
    render() { 
        return (
            <AppLayer>
  {/* start banner section */}
  <section className="d-flex flex-column justify-content-center h-600px cover-background lg-h-400px" style={{backgroundImage: 'url("images/single-project-page-01-img02.jpg")'}}>
    <div className="container">
      <div className="row align-items-center justify-content-center">
        <div className="col-9 col-lg-4 col-sm-5 text-center xs-margin-30px-bottom">
          <img src="images/kp1.png" alt="" />
        </div>
        <div className="col-10 col-lg-8 col-sm-7">
          <div className="position-relative text-center text-sm-end">
            <div className="w-90 h-1px bg-brown position-absolute top-30px right-0px d-none z-index-0 d-sm-block sm-w-100 sm-top-25px" />
            <a href="#" className="bg-brown text-white text-extra-medium line-height-20px z-index-9 position-relative d-inline-block padding-20px-tb padding-35px-lr sm-padding-15px-tb sm-padding-25px-lr">https://4g4.95c.myftpupload.com/</a>
          </div>
        </div>
      </div>
    </div>
  </section>
  {/* end banner section */}
  {/* start section */}
  <section className="bg-light-gray overlap-height wow animate__fadeIn">
    <div className="container">
      <div className="row overlap-gap-section">
        <div className="col-12 col-xl-4 col-lg-5 pe-xl-0 md-margin-30px-bottom">
          <span className="d-block text-small text-uppercase margin-20px-bottom md-margin-10px-bottom">About Krypton Pay</span>
          <h6 className="alt-font text-extra-dark-gray letter-spacing-minus-1px mb-0 w-80 xs-w-100">We are a company invested in making it easy for businesses to accept crypto payments with a priority on fast and secure transactions.</h6>
        </div>
        <div className="col-12 col-lg-2 offset-xl-1 col-md-4 sm-margin-20px-bottom">
          <span className="d-block text-small text-uppercase margin-20px-bottom md-margin-10px-bottom"></span>
          <span className="alt-font text-extra-medium line-height-28px text-extra-dark-gray d-block w-85 md-w-75 xs-w-100"></span>
        </div>
        <div className="col-12 col-lg-2 col-md-4 sm-margin-20px-bottom">
          <span className="d-block text-small text-uppercase margin-20px-bottom md-margin-10px-bottom">Services</span>
          <span className="alt-font text-extra-medium line-height-28px text-extra-dark-gray d-block w-85 md-w-60 xs-w-100">Crypto payment solutions</span>
        </div>
        <div className="col-12 col-lg-3 col-md-4">
          <span className="d-block text-small text-uppercase margin-20px-bottom md-margin-10px-bottom">Client</span>
          <span className="alt-font text-extra-medium line-height-28px text-extra-dark-gray d-block w-85 xs-w-100">Boolean Tech</span>
        </div>
      </div>
    </div>
  </section>
  {/* end section */}
  {/* start section */}
  <section className="overflow-visible position-relative padding-eight-lr xl-padding-five-lr lg-padding-three-lr xs-padding-15px-lr">
    <div className="container-fluid">
      <div className="row">
        {/* <div className="col-12 fix-background overlap-section text-center one-fourth-screen xs-h-300px" style={{backgroundImage: 'url("images/single-project-page-03-img03.jpg")'}} /> */}
        <div className="col-12 fix-background overlap-section text-center xs-h-300px" style={{backgroundImage: 'url("images/kp-2.png")', height: "500px", backgroundSize: "initial"}} />
      </div>
    </div>
  </section>
  {/* end section */}
  {/* start section */}
  <section className="pt-0">
    <div className="container">
      <div className="row">
        <div className="col-12 col-lg-6 md-margin-30px-bottom xs-margin-20px-bottom wow animate__fadeIn" data-wow-delay="0.2s">
          <h5 className="alt-font text-extra-dark-gray mb-0">Start accepting Crypto Payments today!​</h5>
        </div>
        <div className="col-12 col-lg-5 offset-lg-1 last-paragraph-no-margin wow animate__fadeIn" data-wow-delay="0.4s">
          <p>Crypto payments are fast becoming a mainstream payment method, make your business more durable by accepting payments from crypto currency holders.</p>
        </div>
      </div>
    </div>
  </section>
  {/* end section */}
  {/* start section */}
  <section className="py-0 padding-eight-lr xl-padding-five-lr lg-padding-three-lr xs-padding-15px-lr">
    <div className="container-fluid">   
          <img src="images/kp-2.png"></img>
      {/* <div className="row"> */}
        {/* <div className="col-12 col-lg-6 col-sm-6 cover-background one-fourth-screen lg-h-450px md-h-650px sm-h-450px xs-h-650px md-margin-15px-bottom" style={{backgroundImage: 'url("images/kp-2.png")'}} /> */}
        {/* <div className="col-12 col-lg-3 col-sm-6 cover-background one-fourth-screen lg-h-450px md-h-650px sm-h-450px xs-h-650px md-margin-15px-bottom" style={{backgroundImage: 'url("images/single-project-page-03-img06.jpg")'}} /> */}
        {/* <div className="col-12 col-lg-6 cover-background one-fourth-screen lg-h-450px" style={{backgroundImage: 'url("images/single-project-page-03-img05.jpg")'}} /> */}
      {/* </div> */}
    </div>
  </section>
  {/* end section */}
  {/* start section */}
  <section className="pb-0">
    <div className="container">
      <div className="row row-cols-1 row-cols-lg-3 row-cols-sm-2 justify-content-center">
        {/* start services item */}
        <a href="https://4g4.95c.myftpupload.com/2022/03/nft/">
          <div className="col md-margin-30px-bottom xs-margin-15px-bottom wow animate__fadeInLeft" data-wow-delay="0.4s">
            <div className="bg-light-gray last-paragraph-no-margin">
              <img src="images/kp-post1-doge.jpg" alt="" />
                <div className="text-center position-relative padding-3-half-rem-all md-padding-2-half-rem-all">
                  <span className="alt-font text-extra-dark-gray font-weight-500 margin-10px-bottom d-block">
                    NFT
                  </span>
                  <p>NFTs seems to be all the rage these days, there are a lot of hard-to-believe stories about it, stories that range from “Flying war babies”(a digital art) being sold for $5.8 million...</p>
                </div>
            </div>
          </div>
        </a>
        {/* end services item */}
        {/* start services item */}
        <div className="col md-margin-30px-bottom xs-margin-15px-bottom wow animate__fadeInLeft" data-wow-delay="0.2s">
          <div className="bg-light-gray last-paragraph-no-margin">
            <img src="images/kp-post2-crypto.jpg" alt="" />
            <div className="text-center position-relative padding-3-half-rem-all md-padding-2-half-rem-all">
              <span className="alt-font text-extra-dark-gray font-weight-500 margin-10px-bottom d-block">A brief history of cryptocurrency</span>
              <p>A Cryptocurrency is a digital currency designed to work as a form of exchange that works without a central authority to uphold it.
              Bitcoin was created in 2009...</p>
            </div>
          </div>
        </div>
        {/* end services item */}
        {/* start services item */}
        <a href="https://4g4.95c.myftpupload.com/2022/03/nft/">
          <div className="col md-margin-30px-bottom xs-margin-15px-bottom wow animate__fadeInLeft" data-wow-delay="0.4s">
            <div className="bg-light-gray last-paragraph-no-margin">
              <img src="images/kp-post1-doge.jpg" alt="" />
                <div className="text-center position-relative padding-3-half-rem-all md-padding-2-half-rem-all">
                  <span className="alt-font text-extra-dark-gray font-weight-500 margin-10px-bottom d-block">
                    NFT
                  </span>
                  <p>NFTs seems to be all the rage these days, there are a lot of hard-to-believe stories about it, stories that range from “Flying war babies”(a digital art) being sold for $5.8 million...</p>
                </div>
            </div>
          </div>
        </a>
        {/* end services item */}
      </div>
    </div>
  </section>
  {/* end section */}
  {/* start section */}
  <section>
    <div className="container">
      <div className="row justify-content-center">
        <div className="col-12 col-md-10 text-center">
          <span className="alt-font text-small text-uppercase margin-15px-bottom d-inline-block font-weight-500 text-extra-dark-gray">Share this project</span>
          <div className="social-icon-style-10">
            <ul className="large-icon">
              <li><a className="facebook" href="https://www.facebook.com/" target="_blank"><i className="fab fa-facebook-f" /><span /></a></li>
              <li><a className="instagram" href="https://www.instagram.com/kryptonpay.co/" target="_blank"><i className="fab fa-instagram" /><span /></a></li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </section>
  {/* end section */}
  {/* start footer */}
  <footer className="footer-dark bg-slate-blue">
    <div className="footer-top padding-five-tb lg-padding-eight-tb md-padding-50px-tb">
      <div className="container">
        <div className="row">
          {/* start footer column */}
          <div className="col-12 col-lg-4 col-sm-6 md-margin-40px-bottom xs-margin-25px-bottom">
            <span className="alt-font font-weight-500 d-block text-white margin-20px-bottom xs-margin-10px-bottom">Company</span>
            <ul>
              <li><a href="https://4g4.95c.myftpupload.com/about">About company</a></li>
              <li><a href="https://4g4.95c.myftpupload.com/help-center">Help</a></li>
              <li><a href="https://4g4.95c.myftpupload.com/contact">Contact us</a></li>
            </ul>
          </div>
          {/* end footer column */}
          {/* start footer column */}
          <div className="col-12 col-lg-4 col-sm-6 xs-margin-25px-bottom">
            <span className="alt-font font-weight-500 d-block text-white margin-20px-bottom xs-margin-10px-bottom">Get in touch</span>
            <p className="w-85 margin-15px-bottom">56, Ariesului street, Cluj-Napoca, 400456, Cluj, Romania</p>
            <div><i className="feather icon-feather-mail icon-very-small margin-10px-right text-white" /><a href="mailto:coo@theboolean.tech">coo@theboolean.tech</a></div>
          </div>
          {/* end footer column */}
          {/* start footer column */}
          <div className="col-12 col-lg-4 col-sm-6">
            <span className="alt-font font-weight-500 d-block text-white margin-20px-bottom">Follow us on Instagram</span>
            <div className="w-100 d-inline-block margin-10px-top">
              <ul className="instafeed-grid instafeed-wrapper grid grid-3col xl-grid-3col lg-grid-3col md-grid-3col sm-grid-3col xs-grid-3col gutter-small" data-total={3}>
                <li className="grid-item"><figure><a href="#" data-href="{{link}}" target="_blank"><img src="#" data-src="{{image}}" className="insta-image" alt="" /><span className="insta-counts"><i className="fab fa-instagram" />{'{'}{'{'}likes{'}'}{'}'}</span></a></figure></li>
              </ul>
              <a className="alt-font text-extra-small text-uppercase font-weight-500 margin-20px-top d-inline-block" href="https://www.instagram.com/kryptonpay.co/" target="_blank"><i className="fab fa-instagram icon-extra-small align-middle margin-10px-right text-gradient-light-purple-light-orange" /><span className="d-inline-block align-middle">Follow instagram</span></a>
            </div>
          </div>
          {/* end footer column */}
        </div>
      </div>
    </div>
  </footer>
  {/* end footer */}
  {/* start scroll to top */}
  <a className="scroll-top-arrow" href="javascript:void(0);"><i className="feather icon-feather-arrow-up" /></a>
  {/* end scroll to top */}

</AppLayer>

        );
    }
}
 
export default KryptonPay ;